import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { StoreRequestDto, StoreService } from 'src/generated_client';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-login-shop',
  templateUrl: './login-shop.component.html',
  styleUrls: ['./login-shop.component.css']
})

export class LoginShopComponent implements OnInit {

  loginShopForm: FormGroup = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
  })
  hidePassword: boolean = true;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private storeService: StoreService,
    private toastr: ToastrService,

  ) { }

  request: StoreRequestDto = {} as StoreRequestDto;

  ngOnInit(): void {
    this.authService.clearAuthState();
  }

  login(form: any) {

    this.request = {
      dsEmail: form.username,
      dsPassword: form.password
    }

    this.storeService.apiStoreStoreLoginPost(this.request).subscribe(
      x => {
        this.authService.loginStore(x)

        this.router.navigateByUrl('shop-home')
      },
      err => {
        this.toastr.error(err.error.error);

        this.loginShopForm.reset();
      }
    );

    
  }
}
